<template>
  <div class="section-what-is-smartpost">
    <div class="section-header">
      <div class="section-header-highlight title-letter-spacing">
        {{ getWordings.smartpostSectionWhatSubtitle }}
      </div>
      <div class="section-header-text" v-html="getWordings.smartpostSectionWhatTitle"></div>
    </div>
    <div class="description" v-html="getWordings.smartpostSectionWhatDescription"></div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import { Getter } from "vuex-class";

@Component({
  components: {}
})
export default class SectionWhatSmartPOST extends Vue {
  @Getter("text/getWordings") getWordings!: any;
}
</script>

<style lang="scss" scoped>
.section-what-is-smartpost {
  @include layoutPadding;
  padding-top: 100px;
  padding-bottom: 100px;
  @include mq(l) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .smartpost-description {
    margin: auto;
    max-width: 800px;
    margin-top: 60px;
    @include mq(l) {
      margin-top: 40px;
    }
  }
  .description {
    margin: auto;
    max-width: 800px;
    margin-top: 60px;
    @include mq(l) {
      margin-top: 40px;
    }
  }
}
</style>
